import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import { message} from 'antd';
import { useTranslation } from 'react-i18next';

function NavigationAnnouncerComponent() {
	const {t} = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // ignore the /
    if (location.pathname.slice(1)) {
      // make sure navigation has occurred and screen reader is ready
      //setTimeout(() => setMessage(`Navigated to ${location.pathname.slice(1)} page.`), 500)
      message.info(
				t("Navigated to Path page",{path:location.pathname.slice(1)})
			);
    } else {
    	//
		}
  }, [location,t])
  return (
		<>
 		</>	
	)
}

export default NavigationAnnouncerComponent
